export const USER_ROLES = {
  guest: 'ROLE_GUEST',
  consumer: 'ROLE_CONSUMER',
  entrepreneur: 'ROLE_ENTREPRENEUR',
};

export const enum AccountStatusEnum {
  validation = 'VALIDATION',
  validated = 'VALIDATED',
  blocked = 'BLOCKED',
  pending = 'PENDING',
}

export const USER_STATUS_MAP: { [key: number]: AccountStatusEnum } = {
  1: AccountStatusEnum.validation,
  2: AccountStatusEnum.validated,
  3: AccountStatusEnum.blocked,
};

export const enum AccountInfoContext {
  personal = 'personal',
}

export const IMPERSONATION_USER_STATUS_MAP: { [key: number]: AccountStatusEnum } = {
  1: AccountStatusEnum.pending,
  2: AccountStatusEnum.validated,
  3: AccountStatusEnum.blocked,
  4: AccountStatusEnum.validated,
};
